/**
 * Footer slice
 * Fetches and stores admin-configurable footer settings
 * @module features/footer/footerSlice
 */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../app/axios';

const DEFAULT = {
  tagline: 'PearlBridge Voyages & Events Travel connects Uganda and Europe through curated, seamless, and culturally meaningful travel experiences.',
  quickLinks: [
    { label: 'Home',               href: '/' },
    { label: 'Packages',           href: '/mvp/packages' },
    { label: 'Destinations',       href: '/mvp/destinations' },
    { label: 'About',              href: '/about' },
    { label: 'Contact',            href: '/contact' },
    { label: 'Privacy Policy',     href: '/privacy' },
    { label: 'Terms & Conditions', href: '/terms' },
  ],
  serviceLinks: [
    { label: 'Send Inquiry',   href: '/mvp/inquiry' },
    { label: 'Travel Insights', href: '/blog' },
  ],
  socialLinks: [],
  contactEmail:   'info@afribrightcolorex.com',
  contactPhone:   '+46 70 468 30 05',
  contactAddress: 'Furuvägen 14, SE-472 32 Svanesund',
  copyrightName:  'PearlBridge Voyages & Events Travel',
};

export const fetchFooter = createAsyncThunk(
  'footer/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/footer');
      return data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to load footer');
    }
  }
);

export const saveFooter = createAsyncThunk(
  'footer/save',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.put('/footer', payload);
      return data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to save footer');
    }
  }
);

const footerSlice = createSlice({
  name: 'footer',
  initialState: {
    settings: DEFAULT,
    isLoading: false,
    isSaving: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFooter.pending,   (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchFooter.fulfilled, (state, action) => { state.isLoading = false; state.settings = action.payload; })
      .addCase(fetchFooter.rejected,  (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(saveFooter.pending,    (state) => { state.isSaving = true; })
      .addCase(saveFooter.fulfilled,  (state, action) => { state.isSaving = false; state.settings = action.payload; })
      .addCase(saveFooter.rejected,   (state, action) => { state.isSaving = false; state.error = action.payload; });
  },
});

export default footerSlice.reducer;

